import React from "react";
import * as Icon from "../components/icons";
import paycellLogo from '../images/paycell-new-logo-04.png';

export const WINDOW_SIZE ={
    DESKTOP_SIZE : 1270,
    TABLET_SIZE : 980
}

export const MENU = [
       {
        key: 'Telekomünikasyon',
            sectorId: 8 ,
        path: '/internet',
        icon: <Icon.Phone />,
        title: 'Telekomünikasyon'
    },
    {
        key: 'Elektrik',
            sectorId: 3 ,
        path: '/elektrik',
        icon: <Icon.Lightning />,
        title: 'Elektrik'
    },
    {
        key: 'Doğalgaz',
            sectorId: 4 ,
        path: '/dogalgaz',
        icon: <Icon.Flame />,
        title: 'Doğalgaz'
    },
        {
        key: 'Su',
            sectorId: 2 ,
        path: '/su',
        icon: <Icon.Droplet />,
        title: 'Su'
    },
    {
        key: 'Televizyon',
            sectorId: 8 ,
        path: '/televizyon',
        icon: <Icon.Tv />,
        title: 'Televizyon'
    },

    {
        key: 'Turkcell Finansman',
        sectorId: 10,
        path: '/financell',
        icon: <Icon.Financell1/>,
        title: 'Financell'
    },
    {
        key: 'Sigorta',
        sectorId: 52,
        path: '/sigorta',
        icon: <Icon.Anten />,
        title: 'Güvencell'
    }
]

export const ADV_TYPE_MAIN = 'main';
export const ADV_TYPE_RECEIPT = 'receipt';
export const ADV_TYPE_OFFER = 'offer';

export const PAYCELL_LOGO = paycellLogo;